/* dd-before-after-gallery.js
   Horizontal auto-carousel for dd-before-after-gallery.
   Infinite loop via clone strip; pauses on hover, focus, touch, offscreen.
   Respects prefers-reduced-motion. */
(function () {
  if (window._ddBaGalleryInit) return;
  window._ddBaGalleryInit = true;

  var RESUME_MS = 8000;
  var hydrateInflight = Object.create(null);

  function baVariantOptionPills(variant) {
    var pills = [];
    ['option1', 'option2', 'option3'].forEach(function (key) {
      var val = variant[key];
      if (val && val !== 'Default Title') pills.push(val);
    });
    return pills;
  }

  function baVariantImageUrl(variant) {
    if (!variant) return '';
    if (variant.image_url) return variant.image_url;
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    return '';
  }

  function applyBaVariantRow(row, variant) {
    if (!row || !variant) return;
    var productUrl = row.getAttribute('data-ba-product-url') || '';
    if (productUrl && variant.id != null) {
      row.setAttribute('href', productUrl + '?variant=' + variant.id);
    }
    row.removeAttribute('data-ba-needs-hydrate');

    var imageUrl = baVariantImageUrl(variant);
    if (imageUrl) {
      var img = row.querySelector('.dd-glass-card__thumb-img');
      if (img) {
        var base = String(imageUrl).split('?')[0];
        img.src = base + (base.indexOf('cdn.shopify.com') !== -1 ? '?width=96' : '');
      } else {
        var thumb = row.querySelector('.dd-glass-card__thumb');
        if (thumb) {
          var newImg = document.createElement('img');
          newImg.className = 'dd-glass-card__thumb-img';
          newImg.loading = 'lazy';
          newImg.width = 40;
          newImg.height = 40;
          newImg.alt = '';
          newImg.src = String(imageUrl).split('?')[0] + '?width=96';
          thumb.appendChild(newImg);
        }
      }
    }

    var chipsEl = row.querySelector('.dd-ba-card__product-chips');
    if (!chipsEl) return;
    var existing = chipsEl.querySelectorAll('.dd-ba-card__chip-pill');
    for (var i = 1; i < existing.length; i++) {
      existing[i].remove();
    }
    var opts = baVariantOptionPills(variant);
    for (var o = 0; o < opts.length; o++) {
      var span = document.createElement('span');
      span.className = 'dd-ba-card__chip-pill';
      span.textContent = opts[o];
      chipsEl.appendChild(span);
    }
  }

  function fetchBaVariantById(variantId) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    var url = root + 'variants/' + encodeURIComponent(String(variantId)) + '.js';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('variant fetch failed (' + r.status + ')');
      return r.json();
    });
  }

  function hydrateBaVariantRows(scope) {
    var root = scope || document;
    var rows = root.querySelectorAll('[data-ba-needs-hydrate="true"][data-ba-variant-id]');
    if (!rows.length) return;

    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        var vid = row.getAttribute('data-ba-variant-id');
        if (!vid || hydrateInflight[vid]) return;
        hydrateInflight[vid] = true;
        fetchBaVariantById(vid)
          .then(function (variant) {
            if (!variant || String(variant.id) !== String(vid)) return;
            applyBaVariantRow(row, variant);
          })
          .catch(function () {})
          .finally(function () {
            delete hydrateInflight[vid];
          });
      })(rows[i]);
    }
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function getRealCards(scroller) {
    return scroller.querySelectorAll('[data-dd-ba-card]:not([data-dd-ba-clone])');
  }

  function getAllCards(scroller) {
    return scroller.querySelectorAll('[data-dd-ba-card]');
  }

  function getCards(scroller) {
    return getRealCards(scroller);
  }

  function getLoopWidth(scroller, realCount) {
    if (realCount < 2) return 0;

    var allCards = getAllCards(scroller);
    if (allCards.length >= realCount * 3) {
      var mid = realCount;
      var step = allCards[mid + 1].offsetLeft - allCards[mid].offsetLeft;
      if (step > 0) return step * realCount;
    }

    var realCards = getRealCards(scroller);
    if (realCards.length < 2) return 0;
    var fallbackStep = realCards[1].offsetLeft - realCards[0].offsetLeft;
    if (fallbackStep <= 0) return 0;
    return fallbackStep * realCount;
  }

  function markClone(card) {
    card.setAttribute('data-dd-ba-clone', 'true');
    card.setAttribute('aria-hidden', 'true');
    card.setAttribute('tabindex', '-1');
  }

  function setupInfiniteLoop(scroller) {
    if (scroller.getAttribute('data-dd-ba-looped') === '1') {
      var existingCount =
        parseInt(scroller.getAttribute('data-dd-ba-real-count'), 10) || 0;
      return getLoopWidth(scroller, existingCount);
    }

    var realCards = getRealCards(scroller);
    var realCount = realCards.length;
    if (realCount < 2) return 0;

    var step = realCards[1].offsetLeft - realCards[0].offsetLeft;
    if (step <= 0) return 0;

    var prependFrag = document.createDocumentFragment();
    var appendFrag = document.createDocumentFragment();

    for (var i = 0; i < realCount; i++) {
      var headClone = realCards[i].cloneNode(true);
      var tailClone = realCards[i].cloneNode(true);
      markClone(headClone);
      markClone(tailClone);
      prependFrag.appendChild(headClone);
      appendFrag.appendChild(tailClone);
    }

    scroller.insertBefore(prependFrag, scroller.firstChild);
    scroller.appendChild(appendFrag);

    scroller.setAttribute('data-dd-ba-looped', '1');
    scroller.setAttribute('data-dd-ba-real-count', String(realCount));

    var loopWidth = getLoopWidth(scroller, realCount);
    if (loopWidth > 0) {
      scroller.scrollLeft = loopWidth;
    }

    return loopWidth;
  }

  function normalizeInfiniteScroll(scroller) {
    if (scroller.getAttribute('data-dd-ba-looped') !== '1') return;

    var realCount = parseInt(scroller.getAttribute('data-dd-ba-real-count'), 10) || 0;
    var loopWidth = getLoopWidth(scroller, realCount);
    if (loopWidth <= 0) return;

    var edge = 2;
    if (scroller.scrollLeft >= loopWidth * 2 - edge) {
      scroller.scrollLeft -= loopWidth;
    } else if (scroller.scrollLeft <= loopWidth - edge) {
      scroller.scrollLeft += loopWidth;
    }
  }

  function getPhysicalIndex(scroller, cards) {
    if (!cards.length) return 0;
    var scrollLeft = scroller.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs(cards[i].offsetLeft - scrollLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function updateEdgeFade(scroller, cards, realCount) {
    if (!cards.length) return;

    if (scroller.getAttribute('data-dd-ba-looped') === '1' && realCount) {
      var loopWidth = getLoopWidth(scroller, realCount);
      var atLogicalStart = loopWidth > 0 && scroller.scrollLeft <= loopWidth + 2;
      scroller.classList.toggle('is--at-start', atLogicalStart);
      scroller.classList.toggle('is--at-end', false);
      return;
    }

    var atStart = scroller.scrollLeft <= 2;
    var atEnd =
      scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
    scroller.classList.toggle('is--at-start', atStart);
    scroller.classList.toggle('is--at-end', atEnd);
  }

  function scrollToCard(scroller, card, behavior) {
    if (!card) return;
    var left =
      card.getBoundingClientRect().left -
      scroller.getBoundingClientRect().left +
      scroller.scrollLeft;
    scroller.scrollTo({ left: left, behavior: behavior || 'smooth' });
  }

  /* Reuse the already-decoded gallery <img> as the canvas source; only spin
     up a probe Image when the DOM image hasn't finished loading yet. Saves a
     re-decode per probe (3 probes per card, times clones). */
  function withDecodedImage(imgEl, fn) {
    if (imgEl.complete && imgEl.naturalWidth > 0) {
      fn(imgEl, imgEl.naturalWidth, imgEl.naturalHeight);
      return;
    }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      fn(probe, probe.naturalWidth, probe.naturalHeight);
    };
    probe.onerror = function () {
      fn(null, 0, 0);
    };
    probe.src = imgEl.currentSrc || imgEl.src;
  }

  function sampleLum(source, sx, sy, sw, sh, onResult) {
    try {
      var W = 16;
      var H = 8;
      var canvas = document.createElement('canvas');
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(source, sx, sy, sw, sh, 0, 0, W, H);
      var d = ctx.getImageData(0, 0, W, H).data;
      var s = 0;
      var n = 0;
      for (var i = 0; i < d.length; i += 4) {
        s += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
        n++;
      }
      onResult(n > 0 ? s / n : null);
    } catch (e) {
      onResult(null);
    }
  }

  function probeLumRegion(imgEl, region, onResult) {
    withDecodedImage(imgEl, function (source, natW, natH) {
      if (!source || !natW || !natH) return onResult(null);
      var sy;
      var sh;
      if (region === 'top') {
        sy = 0;
        sh = Math.max(1, Math.floor(natH * 0.3));
      } else {
        sy = Math.floor(natH * 0.7);
        sh = natH - sy;
      }
      sampleLum(source, 0, sy, natW, sh, onResult);
    });
  }

  /* Sample only the pixels under `tag`. Maps the tag's layout rect inside
     the figure through the object-fit: cover crop into natural-image
     coordinates, so each badge reads exactly what it sits on. Uses
     offsetLeft/Top (untransformed layout), which stays correct on the
     rotated before-polaroid where getBoundingClientRect would skew. */
  function probeLumUnderTag(fig, imgEl, tag, onResult) {
    withDecodedImage(imgEl, function (source, natW, natH) {
      var figW = fig.clientWidth;
      var figH = fig.clientHeight;
      if (!source || !figW || !figH || !natW || !natH) return onResult(null);

      // object-fit: cover with default 50% 50% object-position
      var scale = Math.max(figW / natW, figH / natH);
      var offX = (natW * scale - figW) / 2;
      var offY = (natH * scale - figH) / 2;

      var sx = (tag.offsetLeft + offX) / scale;
      var sy = (tag.offsetTop + offY) / scale;
      var sw = tag.offsetWidth / scale;
      var sh = tag.offsetHeight / scale;

      sx = Math.max(0, Math.min(natW - 1, sx));
      sy = Math.max(0, Math.min(natH - 1, sy));
      sw = Math.max(1, Math.min(natW - sx, sw));
      sh = Math.max(1, Math.min(natH - sy, sh));

      sampleLum(source, sx, sy, sw, sh, onResult);
    });
  }

  function applyPanelLum(afterFig, lum) {
    if (lum === null || !afterFig) return;
    afterFig.classList.toggle('dd-glass-card--light-bg', lum > 145);
  }

  function applyBentoToneOverride(afterFig, tone) {
    if (!afterFig || !tone || tone === 'auto') return false;
    afterFig.classList.toggle('dd-glass-card--light-bg', tone === 'light');
    return true;
  }

  function applyTagLum(tag, lum) {
    if (lum === null || !tag) return;
    tag.classList.toggle('dd-ba-card__tag--light-bg', lum > 145);
  }

  function initCardContrast(root) {
    var cards = root.querySelectorAll('[data-dd-ba-card]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var beforeFig = card.querySelector('.dd-ba-card__before');
        var afterFig = card.querySelector('.dd-ba-card__after');
        var beforeTag = card.querySelector('.dd-ba-card__tag--before');
        var afterTag = card.querySelector('.dd-ba-card__tag--after');

        if (beforeFig && beforeTag) {
          var beforeImg = beforeFig.querySelector('.dd-ba-card__media');
          if (beforeImg && beforeImg.src) {
            probeLumUnderTag(beforeFig, beforeImg, beforeTag, function (lum) {
              applyTagLum(beforeTag, lum);
            });
          }
        }

        if (afterFig) {
          var afterImg = afterFig.querySelector('.dd-ba-card__media');
          var toneOverride = card.getAttribute('data-bento-tone') || 'auto';
          var panelLocked = applyBentoToneOverride(afterFig, toneOverride);

          if (!panelLocked && afterImg && afterImg.src) {
            probeLumRegion(afterImg, 'bottom', function (lum) {
              applyPanelLum(afterFig, lum);
            });
          }

          if (afterImg && afterImg.src && afterTag) {
            probeLumUnderTag(afterFig, afterImg, afterTag, function (lum) {
              applyTagLum(afterTag, lum);
            });
          }
        }
      })(cards[i]);
    }
  }

  function initGallery(root) {
    if (!root || root.getAttribute('data-dd-ba-init') === '1') return;
    root.setAttribute('data-dd-ba-init', '1');

    var scroller = root.querySelector('[data-dd-ba-scroller]');
    if (!scroller) return;

    var cards = getCards(scroller);
    var realCount = cards.length;
    var isLooped = false;
    var loopWidth = 0;
    var normalizeTimer = null;
    var isAutoplayTick = false;

    function refreshLoopMetrics() {
      cards = getCards(scroller);
      realCount = cards.length;
      if (realCount < 2) return;

      if (scroller.getAttribute('data-dd-ba-looped') !== '1') {
        loopWidth = setupInfiniteLoop(scroller);
        isLooped = loopWidth > 0;
      } else {
        isLooped = true;
        loopWidth = getLoopWidth(scroller, realCount);
      }
    }

    /* An open bento on a card (often a clone) that scrolled fully out of
       view would silently lose its meaning after a loop normalization jump —
       the matching real card stays closed. Close it once it's offscreen so
       DOM state always matches what the viewer can see. */
    function closeOffscreenPanels() {
      var open = scroller.querySelectorAll('.dd-ba-card__bento-details[open]');
      if (!open.length) return;
      var scRect = scroller.getBoundingClientRect();
      for (var i = 0; i < open.length; i++) {
        var cardEl = open[i].closest('[data-dd-ba-card]');
        if (!cardEl) continue;
        var r = cardEl.getBoundingClientRect();
        if (r.right < scRect.left || r.left > scRect.right) {
          open[i].open = false;
        }
      }
    }

    function scheduleNormalize() {
      if (!isLooped) return;
      if (normalizeTimer) clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(function () {
        normalizeTimer = null;
        normalizeInfiniteScroll(scroller);
        closeOffscreenPanels();
        updateEdgeFade(scroller, cards, realCount);
        updateNavButtons();
      }, isAutoplayTick ? 420 : 120);
    }

    refreshLoopMetrics();
    /* After clone setup: clones are probed individually too, instead of
       freezing whatever class state the real card had at clone time. */
    initCardContrast(root);
    root.addEventListener(
      'toggle',
      function (e) {
        if (
          e.target &&
          e.target.matches &&
          e.target.matches('.dd-ba-card__bento-details') &&
          e.target.open
        ) {
          hydrateBaVariantRows(e.target);
        }
      },
      true
    );
    updateEdgeFade(scroller, cards, realCount);
    updateNavButtons();

    var autoplayEnabled = root.classList.contains('dd-ba-gallery--autoplay');
    var intervalMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 5000;
    if (intervalMs < 1000) intervalMs = 5000;

    var timer = null;
    var hoverPaused = false;
    var userPaused = false;
    var resumeTimer = null;
    var visible = false;

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      if (hoverPaused || userPaused || !visible) return;
      /* Someone is reading an open bento — don't slide it away. Resumes
         automatically on the next tick after it closes. */
      if (scroller.querySelector('.dd-ba-card__bento-details[open]')) return;
      var allCards = getAllCards(scroller);
      if (allCards.length < 2 || realCount < 2) return;

      var physical = getPhysicalIndex(scroller, allCards);
      var nextPhysical = physical + 1;
      if (nextPhysical >= allCards.length) nextPhysical = 0;

      isAutoplayTick = true;
      scrollToCard(scroller, allCards[nextPhysical], 'smooth');
      isAutoplayTick = false;
      scheduleNormalize();
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || prefersReducedMotion()) return;
      cards = getCards(scroller);
      if (cards.length < 2) return;
      timer = setInterval(tick, intervalMs);
    }

    function pauseForInteraction() {
      userPaused = true;
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        userPaused = false;
        if (visible && !hoverPaused) startAutoplay();
      }, RESUME_MS);
    }

    function updateNavButtons() {
      var prevBtn = root.querySelector('[data-dd-ba-prev]');
      var nextBtn = root.querySelector('[data-dd-ba-next]');
      if (!prevBtn || !nextBtn) return;

      cards = getCards(scroller);
      if (cards.length < 2) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      if (isLooped) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }

      var allCards = getAllCards(scroller);
      var idx = getPhysicalIndex(scroller, allCards);
      prevBtn.disabled = idx <= 0 && scroller.scrollLeft <= 2;
      nextBtn.disabled =
        idx >= allCards.length - 1 &&
        scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
    }

    function stepCarousel(direction) {
      var allCards = getAllCards(scroller);
      if (allCards.length < 2) return;

      var physical = getPhysicalIndex(scroller, allCards);
      var nextPhysical =
        direction === 'prev'
          ? physical - 1 < 0
            ? allCards.length - 1
            : physical - 1
          : physical + 1 >= allCards.length
            ? 0
            : physical + 1;

      scrollToCard(scroller, allCards[nextPhysical], 'smooth');
      scheduleNormalize();
      pauseForInteraction();
    }

    var prevBtn = root.querySelector('[data-dd-ba-prev]');
    var nextBtn = root.querySelector('[data-dd-ba-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stepCarousel('prev');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stepCarousel('next');
      });
    }

    updateNavButtons();

    var offscreenTimer = null;
    scroller.addEventListener(
      'scroll',
      function () {
        cards = getCards(scroller);
        updateEdgeFade(scroller, cards, realCount);
        updateNavButtons();
        if (isLooped) scheduleNormalize();
        /* Debounced — also covers non-looped scrollers that never normalize. */
        if (offscreenTimer) clearTimeout(offscreenTimer);
        offscreenTimer = setTimeout(closeOffscreenPanels, 250);
      },
      { passive: true }
    );

    scroller.addEventListener('scrollend', scheduleNormalize);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshLoopMetrics();
        if (isLooped && loopWidth > 0) {
          normalizeInfiniteScroll(scroller);
        }
        updateEdgeFade(scroller, cards, realCount);
        updateNavButtons();
      }, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(function () {
          refreshLoopMetrics();
          updateEdgeFade(scroller, cards, realCount);
          updateNavButtons();
        })
        .catch(function () {});
    }

    setTimeout(function () {
      refreshLoopMetrics();
      updateEdgeFade(scroller, cards, realCount);
      updateNavButtons();
      if (visible && !hoverPaused && !userPaused) startAutoplay();
    }, 300);

    scroller.addEventListener('touchstart', pauseForInteraction, { passive: true });
    scroller.addEventListener('wheel', pauseForInteraction, { passive: true });

    root.addEventListener('mouseenter', function () {
      hoverPaused = true;
      stopAutoplay();
    });
    root.addEventListener('mouseleave', function () {
      hoverPaused = false;
      if (visible && !userPaused) startAutoplay();
    });

    root.addEventListener('focusin', function () {
      hoverPaused = true;
      stopAutoplay();
    });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      hoverPaused = false;
      if (visible && !userPaused) startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible && !hoverPaused && !userPaused) {
              startAutoplay();
            } else {
              stopAutoplay();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(root);
    } else {
      visible = true;
      startAutoplay();
    }
  }

  function initAll(scope) {
    var root = scope || document;
    var galleries = root.querySelectorAll('[data-dd-ba-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      initGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAll(e.target);
  });
})();
